module.exports = __webpack_public_path__ + "img/picnic.ce8f004b.svg";